import {
  handleDeleteApi,
  handlePostApi,
  handleUpdatePostApi,
} from '@/api/crud';
import { versionApiEndpoints } from '@/api/endpoints';
import { ShowAllData } from '@/apiError/apiShow';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiService from '@/apiError/apiServices';
import { API } from '@/api/config';

export const useVersions = (navigate) => {
  return useQuery({
    queryKey: ['getVersions'],
    queryFn: async () =>
      await ShowAllData.showDetails('/superadmin/versions/', navigate),
  });
};

export const useCreateVersions = () => {
  // const setLoading = () => {};
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (value) => await API.post('/superadmin/versions/', value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getVersions'] });
    },
  });
};

export const useUpdateVersions = () => {
  // const setLoading = () => {};
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (value) =>
      await API.patch(`/superadmin/versions/${value.referenceId}/`, value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getVersions'] });
    },
  });
};

export const useDeleteVersions = () => {
  // const setLoading = () => {};
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await API.delete(`/superadmin/versions/${id}/`);

      if (data.ResponseCode == '0') {
        queryClient.invalidateQueries({ queryKey: ['getVersions'] });
      }

      return data;
    },
  });
};
